/* tslint:disable */
/* eslint-disable */
/**
 * Intranet - Notifications API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BooleanResponse } from '../models';
// @ts-ignore
import type { NotificationResponse } from '../models';
// @ts-ignore
import type { NotificationSearchResponseResponse } from '../models';
// @ts-ignore
import type { ObjectResponse } from '../models';
// @ts-ignore
import type { StringResponse } from '../models';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnConnectPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionConnectionsOnConnectPost', 'version', version)
            const localVarPath = `/api/v{version}/Connections/onConnect`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnDisconnectPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionConnectionsOnDisconnectPost', 'version', version)
            const localVarPath = `/api/v{version}/Connections/OnDisconnect`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetAllGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetAllGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetAll`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetCountGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetCountGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetCount`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetRecentGet: async (version: string, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetRecentGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetRecent`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationKeyGet: async (version: string, timestamp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationKeyGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/key`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkAllAsReadPut: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkAllAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-all-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkItemAsReadPut: async (version: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkItemAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-item-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkListAsReadPut: async (version: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkListAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-list-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationPushNewPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationPushNewPost', 'version', version)
            const localVarPath = `/api/v{version}/Notification/push-new`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationSkipAndTakeGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationSkipAndTakeGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/SkipAndTake`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionConnectionsOnConnectPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionConnectionsOnConnectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionConnectionsOnDisconnectPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionConnectionsOnDisconnectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetAllGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetCountGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetRecentGet(version, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationKeyGet(version, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkAllAsReadPut(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkAllAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkItemAsReadPut(version, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkItemAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkListAsReadPut(version, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkListAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationPushNewPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationPushNewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationSkipAndTakeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ObjectResponse> {
            return localVarFp.apiVversionConnectionsOnConnectPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ObjectResponse> {
            return localVarFp.apiVversionConnectionsOnDisconnectPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetAllGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetCountGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetRecentGet(version, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.apiVversionNotificationKeyGet(version, timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkAllAsReadPut(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkItemAsReadPut(version, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkListAsReadPut(version, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationPushNewPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Web Socket on connect endpoint.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionConnectionsOnConnectPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Web Socket on disConnect endpoint.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionConnectionsOnDisconnectPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetAllGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetCountGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recent unread Notifications and total count of unread notifications.
     * @param {string} version 
     * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetRecentGet(version, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationKeyGet(version, timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks all unread notifications as read
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkAllAsReadPut(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks one notification as read
     * @param {string} version 
     * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkItemAsReadPut(version, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a list of notifications as read
     * @param {string} version 
     * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkListAsReadPut(version, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Posts notifications from notification processing lambda. We use these to check for active users.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationPushNewPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
     * @param {string} version 
     * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

